import { createSignal } from '@verclam/pulsar';

/** Whether the creation form is open on the empty ("unconfigured") screen. */
const ssoCreationSignal = createSignal<boolean>(false);

export const setSsoCreationOpen = (isOpen: boolean): void => {
	ssoCreationSignal.value = isOpen;
};

export default ssoCreationSignal;
